import React, { createContext, useContext, useEffect, useState } from "react";

const KEY = "highkey_batch_mode";
const BatchModeContext = createContext(null);

export const BatchModeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => localStorage.getItem(KEY) || "small");
  useEffect(() => {
    localStorage.setItem(KEY, mode);
  }, [mode]);
  return (
    <BatchModeContext.Provider value={{ mode, setMode }}>
      {children}
    </BatchModeContext.Provider>
  );
};

export const useBatchMode = () => useContext(BatchModeContext);
